import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from '@psei/ng/select';
import { PseicFormFieldModule } from '../pseic-form-field/pseic-form-field.module';
import { PseicPhoneComponent } from './pseic-phone.component';


@NgModule({
  declarations: [PseicPhoneComponent],
  imports: [
    CommonModule,
    SelectModule,
    PseicFormFieldModule,
    ReactiveFormsModule,
    FlexModule
  ],
  exports: [PseicPhoneComponent]
})
export class PseicPhoneModule {}
